import React from 'react';
import type { PanelInterventionDetail } from '../InterventionsCreate';

/** Bloc « Paramètres + récompense + type de scénario » extrait de InterventionsCreate.tsx. */

interface InterventionParamsSectionProps {
  d: PanelInterventionDetail | null;
  scenarioKind: 'aucun' | 'tuto' | 'exceptionnelle';
  setScenarioKind: (v: 'aucun' | 'tuto' | 'exceptionnelle') => void;
}

const NumberInput: React.FC<{ name: string; defaultValue: number; min?: number; label: string }> = ({
  name,
  defaultValue,
  min = 0,
  label,
}) => (
  <div>
    <label className="block text-sm font-medium text-gray-300 mb-2">{label}</label>
    <input
      type="number"
      name={name}
      defaultValue={defaultValue}
      min={min}
      className="w-full px-4 py-2 bg-gray-800/50 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
    />
  </div>
);

const InterventionParamsSection: React.FC<InterventionParamsSectionProps> = ({
  d,
  scenarioKind,
  setScenarioKind,
}) => (
  <>
    <NumberInput name="temps_max" defaultValue={d?.params?.temps_max ?? 15} min={1} label="Temps max (minutes)" />
    <NumberInput name="victimes_min" defaultValue={d?.params?.victimes_min ?? 0} label="Victimes (min)" />
    <NumberInput name="victimes_max" defaultValue={d?.params?.victimes_max ?? 0} label="Victimes (max)" />
    <NumberInput name="hostiles_min" defaultValue={d?.params?.hostiles_min ?? 0} label="Hostiles (min)" />
    <NumberInput name="hostiles_max" defaultValue={d?.params?.hostiles_max ?? 0} label="Hostiles (max)" />
    <NumberInput
      name="vehicules_accidentes_min"
      defaultValue={d?.params?.vehicules_accidentes_min ?? 0}
      label="Véhicules accidentés (min)"
    />
    <NumberInput
      name="vehicules_accidentes_max"
      defaultValue={d?.params?.vehicules_accidentes_max ?? 0}
      label="Véhicules accidentés (max)"
    />

    <div className="md:col-span-2 border-t border-gray-700 pt-4 mt-2">
      <label className="block text-sm font-medium text-gray-300 mb-3">
        Récompense de l'intervention
      </label>
      <p className="text-xs text-gray-500 mb-3">
        XP et € accordés une fois l'intervention terminée.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs text-gray-400 mb-1">XP</label>
          <input
            type="number"
            name="recompense_xp"
            defaultValue={d?.recompense?.xp ?? 0}
            min={0}
            className="w-full px-4 py-2 bg-gray-800/50 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>
        <div>
          <label className="block text-xs text-gray-400 mb-1">€</label>
          <input
            type="number"
            name="recompense_credits"
            defaultValue={d?.recompense?.credits ?? 0}
            min={0}
            className="w-full px-4 py-2 bg-gray-800/50 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>
      </div>
    </div>

    <div className="md:col-span-2 space-y-3">
      <p className="text-xs text-gray-500">
        Type de scénario (optionnel) : choisir au plus une option — tutoriel ou exceptionnelle, pas les deux.
      </p>
      <label className="flex items-center space-x-3 cursor-pointer">
        <input
          type="checkbox"
          checked={scenarioKind === 'tuto'}
          onChange={(e) => setScenarioKind(e.target.checked ? 'tuto' : 'aucun')}
          className="w-5 h-5 rounded bg-gray-800/50 border-gray-700 text-primary-600 focus:ring-2 focus:ring-primary-500"
        />
        <span className="text-sm font-medium text-gray-300">Intervention tutoriel</span>
        <span className="text-xs text-gray-400">(Destinée à l&apos;apprentissage)</span>
      </label>
      <label className="flex items-center space-x-3 cursor-pointer">
        <input
          type="checkbox"
          checked={scenarioKind === 'exceptionnelle'}
          onChange={(e) => setScenarioKind(e.target.checked ? 'exceptionnelle' : 'aucun')}
          className="w-5 h-5 rounded bg-gray-800/50 border-gray-700 text-primary-600 focus:ring-2 focus:ring-primary-500"
        />
        <span className="text-sm font-medium text-gray-300">Intervention exceptionnelle</span>
        <span className="text-xs text-gray-400">(Événement rare ou hors routine)</span>
      </label>
    </div>
  </>
);

export default InterventionParamsSection;
